import classNames from 'classnames/bind';
import { CommonButton } from '../common/button';
import styles from './chromeDownload.module.scss';
import React from 'react';

const cx = classNames.bind(styles);
const chromeDownloadUrl = 'https://www.google.com/chrome/';

export const ChromeDownload = () => {
  const handleDownloadClick = () => {
    window.open(chromeDownloadUrl, '_blank');
  };

  return (
    <div className={cx('chromeDownload')}>
      <div className={cx('message')}>
        기출 면접 연습은 크롬에서만 <br />
        응시가 가능합니다.
      </div>
      <div className={cx('btnWrap')}>
        <CommonButton className={cx('btnDownload')} type={'green'} onClick={handleDownloadClick}>
          크롬 브라우저 다운로드
        </CommonButton>
      </div>
    </div>
  );
};
